export enum UserRequestActionState {
    INFORMATION = 0,
    DETAILS = 1,
    FOLLOWUP = 2
}